import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/api"; 
import "../../App.css"; 
// Adjust path if needed
import logo from "../../images/SPFLLOGO.png"; 

import ExcelExport from "../../UserControls/ExcelExport/ExcelExport";

// Helper function to format date-time strings
const formatDate = (dateTimeStr) => {
  if (!dateTimeStr) return 'N/A';
  try {
    const date = new Date(dateTimeStr);
    // Format: DD/MM/YYYY HH:MM
    return date.toLocaleString('en-GB', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).replace(',', ' '); 
  } catch {
    return 'Invalid Date';
  }
};


const getStatusColor = (status) => {
  if (!status) return 'gray';
  const lowerStatus = status.toLowerCase();
  if (lowerStatus.includes("open") || lowerStatus.includes("pending")) {
    return "#ffc107"; 
  } else if (lowerStatus.includes("closed") || lowerStatus.includes("solved")) {
    return "#28a745"; 
  }
  return "#007bff"; 
};

const ServiceList = () => {
  const [services, setServices] = useState([]);
  const [filteredServices, setFilteredServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [viewMode, setViewMode] = useState("table"); // card or table
  const navigate = useNavigate();
  
  const userName = sessionStorage.getItem("userName"); 
  const companyName = sessionStorage.getItem("companyName");

  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        const data = await api.GetServiceList(userName); 

        let serviceTable = [];

        if (data && data.Table && Array.isArray(data.Table)) {
          serviceTable = data.Table;
        } else {

          console.error("Unexpected API structure or empty list:", data);
        }

        
        if (serviceTable.length > 0) {

          const sorted = [...serviceTable].sort((a, b) => (b.ServiceId || 0) - (a.ServiceId || 0));
          setServices(sorted);
          setFilteredServices(sorted);
        } else if (serviceTable.length === 0) {
            setServices([]);
            setFilteredServices([]);
        } 
        else {
          setError("Unexpected API response structure or empty service list.");
        }
      } catch (err) {
        console.error("Error fetching services:", err);
        setError("Failed to fetch service list. Please check connectivity.");
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, [userName]);

  useEffect(() => {
    const filtered = services.filter((s) =>
      Object.values(s).some(
        
        (val) =>
          val != null &&
          val.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
    setFilteredServices(filtered);
  }, [searchTerm, services]);

  if (loading) {
    return <div className="loading">Loading services...</div>;
  }

  if (error) {
    return (
      <div className="error">
        {error}{" "}
        <button onClick={() => window.location.reload()} className="btn-retry">
          Retry
        </button>
      </div>
    );
  }

  return (
     <div className="service-container">
        {/* 🧩 Header Styling: Added for the new logo/company name layout */}
       <style>{`
        /* Container for the logo/company name and the page title */
        .header-controls {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 20px;
            background: #fff;
            padding: 15px 20px;
            border-radius: 10px;
            box-shadow: 0 2px 6px rgba(0,0,0,0.1);
            position: relative; /* Allows logo-and-name to be positioned absolutely */
        }

        /* Div to hold logo and company name in a single row */
        .logo-and-name {
            display: flex;
            align-items: center;
            /* 👇 ADJUSTED: Moved from 20px to 40px to shift right */
            position: absolute;
            left: 50px; 
            top: 50%;
            transform: translateY(-50%);
        }

        .logo-and-name img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background-color: white;
            box-shadow: 0 0 4px rgba(0,0,0,0.2);
            padding: 5px;
            margin-right: 1px;
            object-fit: contain;
        }

        .logo-and-name h1 {
            font-size: 22px;
            font-weight: bold;
            color: #333;
            margin: 0;
            text-align: left;
        }
        
        /* Ensures the title is centered */
        .page-title {
            text-align: center;
            font-size: 1.4rem;
            font-weight: 500;
            color: #1f2937;
            margin: 0;
        }



        /* 📱 Mobile & Tablet Responsive Enhancements */
@media (max-width: 1024px) {
  .header-controls {
    flex-direction: column;
    text-align: center;
    padding: 10px;
  }

  .logo-and-name {
    position: relative;
    left: 0;
    top: 0;
    transform: none;
    justify-content: center;
    margin-bottom: 8px;
  }

  .logo-and-name img {
    width: 45px;
    height: 45px;
    margin-right: 6px;
  }

  .logo-and-name h1 {
    font-size: 18px;
  }

  .page-title {
    font-size: 1.2rem;
  }

  .top-controls {
    flex-direction: column;
    align-items: center;
    gap: 10px;
    width: 100%;
  }

  .top-right-controls {
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
  }

  .search-box {
    width: 100%;
    max-width: 300px;
  }

  .search-input {
    width: 100%;
  }

  .view-icons {
    display: flex;
    justify-content: center;
  }

  .grid-cards {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 10px;
  }

  .asset-card {
    width: 100%;
  }

  .table-wrapper {
    overflow-x: auto;
  }

  .asset-table {
    min-width: 800px;
  }

  .btn-primary,
  .btn-edit,
  .btn-edit-small {
    font-size: 0.9rem;
    padding: 6px 10px;
  }
}

@media (max-width: 480px) {
  .logo-and-name img {
    width: 40px;
    height: 40px;
  }

  .logo-and-name h1 {
    font-size: 16px;
  }

  .page-title {
    font-size: 1rem;
  }

  .btn-primary {
    width: 100%;
  }

  .asset-card h3 {
    font-size: 1rem;
  }

  .asset-card p {
    font-size: 0.85rem;
  }

  .view-icons button {
    padding: 4px;
  }

  .search-box {
    max-width: 100%;
  }

  .top-controls {
    padding: 0 10px;
  }

  .header-controls {
    padding: 8px;
  }
}



      `}</style>

      {/* 🛑 Replaced old inline-styled logo/name div with the new class-based structure */}
      <div className="header-controls">
        <div className="logo-and-name">
          {/* <img src={logo} alt="Company Logo" /> */}
          <h1>{companyName}</h1>
        </div>
        <h2 className="page-title">Service List</h2>
      </div>
      <div className="top-controls">
        <button
          className="btn-primary"

         onClick={() => navigate("/ServiceForm")}
        >
          ➕ New Service
        </button>
     
     

        <div className="top-right-controls">
<ExcelExport data={filteredServices} fileName="ServiceList" />
          <div className="search-box">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="search-icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z"
              />
            </svg>
            <input
              type="text"
              placeholder="Search services..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>

          <div className="view-icons">
            <button
              onClick={() => setViewMode("card")}
              className={`icon-btn ${viewMode === "card" ? "active" : ""}`}
              title="Card View"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon-svg"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z" />
              </svg>
            </button>

            <button
              onClick={() => setViewMode("table")}
              className={`icon-btn ${viewMode === "table" ? "active" : ""}`}
              title="Table View"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon-svg"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M4 6h16v2H4V6zm0 4h16v2H4v-2zm0 4h16v2H4v-2zm0 4h16v2H4v-2z" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {filteredServices.length === 0 ? (
        <p className="mt-4 text-center text-gray-500">No services found.</p>
      ) : viewMode === "card" ? (
        // ✅ Card View 
        <div className="grid-cards">
          {filteredServices.map((s) => (
            <div key={s.ServiceId} className="asset-card">
              <h3>{s.ServiceNo}</h3>
              <p>
                <strong>Asset:</strong> {s.AssetName}
              </p>
              <p>
                <strong>Issue:</strong> {s.IssueName}
              </p>
              <p>
                <strong>Type:</strong> {s.ServiceType}
              </p>
              <p>
                <strong>Serviced By:</strong> {s.ServiceBy}
              </p>
              <p>
                <strong>Start:</strong> {formatDate(s.ServiceStartTime)}
              </p>
              {/* Status color indicator */}
              <p>
                <strong>Status:</strong>{" "}
                <span
                  style={{
                    color: getStatusColor(s.Status),
                    fontWeight: "bold",
                  }}
                >
                  {s.Status}
                </span>
              </p>
              <button
                className="btn-edit"
                // Navigate to a form for editing this specific service
                onClick={() => navigate(`/ServiceForm/${s.ServiceId}`)} 
              >
                ✏️ Edit
              </button>
            </div>
          ))}
        </div>
      ) : (
        // ✅ Table View
        <div className="table-wrapper">
          <table className="asset-table">
            <thead>
              <tr>
                <th style={{ width: "10%" }}>Service No</th>
                <th style={{ width: "15%" }}>Asset Name</th>
                <th style={{ width: "15%" }}>Issue Name</th>
                <th style={{ width: "10%" }}>Service Type</th>
                <th style={{ width: "15%" }}>Serviced By</th>
                <th style={{ width: "15%" }}>Start Time</th>
                <th style={{ width: "10%" }}>Status</th>
                <th style={{ width: "10%" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredServices.map((s) => (
                <tr key={s.ServiceId}>
                  <td>{s.ServiceNo}</td>
                  <td>{s.AssetName}</td>
                  <td>{s.IssueName}</td>
                  <td>{s.ServiceType}</td>
                  <td>{s.ServiceBy}</td>
                  <td>{formatDate(s.ServiceStartTime)}</td>
                  <td>
                    <span
                      style={{
                        color: getStatusColor(s.Status),
                        fontWeight: "bold",
                      }}
                    >
                      {s.Status}
                    </span>
                  </td>
                  <td>
                    <button
                      className="btn-edit-small"
                      onClick={() => navigate(`/ServiceForm/${s.ServiceId}`)}
                    >
                      ✏️ Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ServiceList;